import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Button, Divider, Icon } from "semantic-ui-react";

import Schedule from "../../containers/schedules/Schedule.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";

import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ScheduleHeader extends Component {
  static propTypes = {
    createScheduleAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  render() {
    const {
      createScheduleAvailability: { available, enabled },
      copy
    } = this.props;

    if (available !== true) return null;

    return (
      <Container>
        <Button
          as={LinkWithReset}
          to={Schedule.WIZARD_URI}
          floated="right"
          className="add-project-button"
          disabled={!enabled}
        >
          <Icon name="plus circle" />
          {copy("schedules.add_new_schedule")}
        </Button>
        <Divider clearing />
      </Container>
    );

    return null;
  }
}

const mapStateToProps = state => ({
  createScheduleAvailability: selectOperationAvailability(state)(
    AT_TYPES.SCHEDULE,
    OPERATIONS.CREATE
  ),
  copy: selectCopy(state)
});

export default connect(mapStateToProps, null)(ScheduleHeader);
